
import { useEffect, useRef, useCallback } from 'react';
import { Dungeon } from '../types';
import { supabase } from '../utils/supabaseClient';
import { RealtimeChannel } from '@supabase/supabase-js';

export const useDungeonSync = (onUpdate?: (dungeon: Dungeon) => void, sessionId: string = 'default-session') => {
  const channelRef = useRef<RealtimeChannel | null>(null);

  useEffect(() => {
    // Inscrever no canal do Supabase Realtime
    const channel = supabase.channel(`dungeon-sync-${sessionId}`, {
      config: {
        broadcast: { self: false }
      }
    });

    channel
      .on('broadcast', { event: 'dungeon-update' }, (payload) => {
        if (onUpdate && payload.payload) {
          onUpdate(payload.payload as Dungeon);
        }
      })
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          console.log(`Conectado ao canal de sincronização: ${sessionId}`);
        }
      });

    channelRef.current = channel;

    return () => {
      if (channelRef.current) {
        supabase.removeChannel(channelRef.current);
      }
    };
  }, [onUpdate, sessionId]);

  const broadcastDungeon = useCallback((dungeon: Dungeon) => {
    if (channelRef.current) {
      channelRef.current.send({
        type: 'broadcast',
        event: 'dungeon-update',
        payload: dungeon,
      });
    }
  }, []);

  return { broadcastDungeon };
};
